module.exports = __webpack_public_path__ + "static/sortprojects-694aec9508b3842671a9d26926f1b346.mp4";